import { useState, useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { Button } from "react-bootstrap";
import moment from "moment";
import { baseUrl } from "../../utils/apiActions/dashboardApi";
import { toastError, toastSuccess } from "../../utils/toastrResponse";
import marker from "../../assets/img/marker.png";
import useAxios from "../../hooks/useAxios";

const AssignAgentLocation = ({ setStep, agentId, hide }) => {
  const [disabled, setDisabled] = useState(true);
  const [province, setProvince] = useState([]);
  const [district, setDistrict] = useState([]);
  const [sector, setSector] = useState([]);
  const [cell, setCell] = useState([]);
  const [village, setVillage] = useState([]);
  const [districtId, setDistrictId] = useState();
  const [sectorId, setSectorId] = useState();
  const [cellId, setCellId] = useState();
  const locations = JSON.parse(localStorage.getItem("locations"));
  const [selectedLocations, setSelectedLocations] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const [locationId, setLocationId] = useState(user.location_id);
  const queryClient = useQueryClient();
  const axiosInstance = useAxios();
  // fetch locations
  const fetchNavigator = useCallback(
    async (location, location_id) => {
      const url = `/locations/${location_id}/sublocations`;
      try {
        const res = await axiosInstance.get(url);
        if (res.status >= 200 && res.status <= 300) {
          if (location === "province") {
            setProvince(res.data);
          } else if (location === "district") {
            setDistrict(res.data);
          } else if (location === "sector") {
            setSector(res.data);
          } else if (location === "cell") {
            setCell(res.data);
          } else {
            setVillage(res.data);
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    [locationId]
  );
  // Assign agent to a locations
  const assingAgentToLocation = (e) => {
    e.preventDefault();
    const urlPrefix =
      selectedLocations.length > 1 ? "multiplelocations" : "locations";
    const date = moment().format("YYYY-MM-DD");
    const startDatetime = `${date}T17:19:00.00Z`;
    const endDatetime = "2099-03-21T17:19:00.00Z";
    const locations = [];
    selectedLocations.forEach((location) => {
      locations.push({
        agentId,
        locationId: location.locationId,
        startDatetime,
        endDatetime,
      });
    });
    const dataToSend = {
      locationId,
      agentId,
      startDatetime,
      endDatetime,
    };
    const url = `${baseUrl}/agents/${agentId}/${urlPrefix}`;
    axiosInstance({
      url,
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: selectedLocations.length > 1 ? locations : dataToSend,
    })
      .then((res) => {
        if (res.status >= 200 && res.status <= 300) {
          setStep(0);
          setSelectedLocations([]);
          toastSuccess("Location Assigned to agent");
          hide(false);
          queryClient.invalidateQueries(["fetch-agents"]);
        } else {
          toastError("Could not assign location to Agent");
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <div>
      <form className='mt-5' onSubmit={assingAgentToLocation}>
        <div>
          <select
            className='form-control input-select'
            onClick={() => fetchNavigator("province")}
            onChange={(e) => setLocationId(e.target.value)}
          >
            {!locations[0]?.name && <option>Province</option>}
            {locations[0]?.name ? (
              <option>{locations[0]?.name}</option>
            ) : (
              <>
                {village?.map((el, index) => (
                  <>
                    <option value={el.id} key={index}>
                      {el.name}
                    </option>
                  </>
                ))}
              </>
            )}
          </select>
        </div>
        <div className='mt-2'>
          <select
            className='form-control input-select'
            onClick={() => {
              if (!locations[1]) {
                fetchNavigator("district", locations[0]?.id);
              }
            }}
            onChange={(e) => {
              setLocationId(e.target.value);
              setDistrictId(e.target.value);
              setSector([]);
              setCell([]);
              setVillage([]);
              setSelectedLocations([]);
              setDisabled(true);
            }}
          >
            {!locations[1]?.name && <option>District</option>}
            {district.length > 0 ? (
              <>
                {district?.map((el) => (
                  <>
                    <option key={el.id} value={el.id}>
                      {el.name}
                    </option>
                  </>
                ))}
              </>
            ) : locations[0]?.name ? (
              <option>{locations[1]?.name}</option>
            ) : (
              <option>District</option>
            )}
          </select>
        </div>
        <div className='mt-2'>
          <select
            className='form-control input-select'
            onClick={() => {
              if (!locations[2]) {
                fetchNavigator("sector", districtId || locations[1]?.id);
              }
            }}
            onChange={(e) => {
              setSectorId(e.target.value);
              setLocationId(e.target.value);
              setCell([]);
              setVillage([]);
              setSelectedLocations([]);
              setDisabled(true);
            }}
          >
            {!locations[2]?.name && <option>Sector</option>}
            {sector.length > 0 ? (
              <>
                {sector?.map((el, index) => (
                  <>
                    <option key={index} value={el.id}>
                      {el.name}
                    </option>
                  </>
                ))}
              </>
            ) : (
              <option>{locations[2]?.name}</option>
            )}
          </select>
        </div>
        <div className='mt-2'>
          <select
            className='form-control input-select'
            onClick={() => {
              if (!locations[3]) {
                fetchNavigator("cell", sectorId || locations[2]?.id);
              }
            }}
            onChange={(e) => {
              setCellId(e.target.value);
              setLocationId(e.target.value);
              setVillage([]);
              setSelectedLocations([]);
              setDisabled(true);
            }}
          >
            {!locations[3]?.name && <option value=''>Cell</option>}
            {cell.length > 0 ? (
              <>
                {cell?.map((el, index) => (
                  <>
                    <option key={index} value={el.id}>
                      {el.name}
                    </option>
                  </>
                ))}
              </>
            ) : (
              <option>{locations[3]?.name}</option>
            )}
          </select>
        </div>
        <div className='mt-2 d-flex' style={{ gap: 10 }}>
          <select
            className='form-control input-select'
            onClick={() => {
              if (!locations[4]) {
                fetchNavigator("village", cellId || locations[3]?.id);
              }
            }}
            onChange={(e) => {
              const { options, value } = e.target;
              const label = options[options.selectedIndex].label;
              if (selectedLocations.length === 0) {
                setDisabled(false);
              }
              setLocationId(value);
              const isExist = selectedLocations.filter(
                (lb) => lb.locationId === value
              );
              if (!isExist.length > 0 && value !== "") {
                selectedLocations.push({
                  locationId: value,
                  label,
                });
              }
            }}
          >
            {!locations[4]?.name && <option value=''>Village</option>}
            {village.length > 0 ? (
              <>
                {village?.map((el) => (
                  <>
                    <option key={el.id} value={el.id}>
                      {el.name}
                    </option>
                  </>
                ))}
              </>
            ) : (
              <option>{locations[4]?.name}</option>
            )}
          </select>
          <div
            style={{
              width: 35,
              height: 25,
              cursor: "pointer",
            }}
            onClick={() => {
              setVillage([]);
            }}
            className='mt-2'
            title='Add location'
          >
            <img src={marker} alt='location icon' />
          </div>
        </div>
        <div className='d-flex flex-wrap' style={{ gap: 10 }}>
          {selectedLocations?.map((location, index) => (
            <div
              className='d-flex mt-2 pl-1 pb-1 pr-1'
              key={location.id}
              style={{
                border: "1px #eee solid",
                backgroundColor: "#e9ecef",
                maxWidth: 100,
                borderRadius: 5,
              }}
            >
              {location.label}
              <div
                className='d-flex justify-content-center mt-1 ml-2'
                style={{
                  width: 13,
                  height: 13,
                  borderRadius: "50%",
                  backgroundColor: "#8f250d",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={() => {
                  const updatedLocation = [...selectedLocations];
                  updatedLocation.splice(index, 1);
                  setSelectedLocations([...updatedLocation]);
                  if (index === 0 && selectedLocations.length === 1) {
                    setDisabled(true);
                  } else {
                    setDisabled(false);
                  }
                }}
              >
                <span
                  style={{
                    fontSize: 10,
                    color: "#FFF",
                    marginBottom: 2,
                  }}
                >
                  x
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className='d-flex justify-content-center'>
          <Button
            className='custom-btn-color'
            disabled={disabled}
            type='submit'
          >
            Save Location
          </Button>
        </div>
      </form>
    </div>
  );
};

export default AssignAgentLocation;
